import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Model_Constant_Search_Fields: {[id:string]: ISearchProviderField} = {
    WB_MODEL_CONSTANT_ID:         {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Model Constant Id',       columnResourceName: 'colId',          alignment: HorizAlignment.Left},  domainOptions: {}},
    CONSTANT_NAME:          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Model Constant Name',        columnResourceName: 'colName',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CONSTANT_ID:            {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Model Constant ID',          columnResourceName: 'colPId',         alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    COMMENTS:                  {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Comments',                columnResourceName: 'colComments',    alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    WB_TREE_FOLDER_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Tree Folder'}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const ModelConstantSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_MODEL_CONSTANT_ID',
                id_ui: 'CONSTANT_ID',
                name: 'CONSTANT_NAME'

    },

    searchProviderFields: vUI_Model_Constant_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Model_Constant_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res:any)=>{
                    resolve(res)
                })
                .catch((err)=>{
                    error(err)
                })
        })
    }
};

const ModelConstantSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "ModelConstantSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'CONSTANT_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'CONSTANT_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'CONSTANT_ID', 'CONSTANT_NAME',
        "CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelConstantSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ModelConstantSearch: ISearch = {
    searchName: "Find Model Constant",
    renderOptions: {ui5ResourceId: "ModelConstantSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ModelConstantSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ModelConstantBO", "ModelConstant", ModelConstantSearch, "Model Constant Search")

export {ModelConstantSearch}
